import { render, staticRenderFns } from "./privacy-preview.vue?vue&type=template&id=9a0fcbc2&scoped=true&"
import script from "./privacy-preview.vue?vue&type=script&lang=js&"
export * from "./privacy-preview.vue?vue&type=script&lang=js&"
import style0 from "./privacy-preview.vue?vue&type=style&index=0&id=9a0fcbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0fcbc2",
  null
  
)

export default component.exports